export enum InterviewRoundStatus {
    PENDING_SCHEDULE = 'PENDING_SCHEDULE',
    SCHEDULED = 'SCHEDULED',
    PENDING_COMPLETE = 'PENDING_COMPLETE', // These are the ones which are scheduled and start date is passed. So that means they are pending to be completed now.
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    ARCHIVED = 'ARCHIVED',
}
